'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



// WEBPACK FOOTER //
// ../axios/lib/cancel/isCancel.js